import { Component, OnInit } from '@angular/core';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute } from '@angular/router';
import { Practice } from 'src/app/models/practice';
import { ReportingService } from 'src/app/services/reporting.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss']
})
export class ReportingComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public loadedPractice:boolean=false;
  public practiceProgrammes=[];
  public practiceProgrammeMemberData=[];
  public memberTotals=[];
  public params={
    fromDate : new Date((new Date()).getFullYear(), 0, 1),
    toDate : new Date(),
    role : 'all',
    status : 'all'
  };
  public reportData;
  public showWorking:boolean=false;

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute,
    private _reporting: ReportingService
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
      }
    );
  }

  public generateReport(){
    this.reportData=null;
    this.showWorking=true;
    // this._reporting.generateReport(this.params, this.practiceId).subscribe(
    //   res=>{
    //     this.reportData=res[0].members;
    //     this.practiceProgrammes=res[1];
    //     this.practiceProgrammeMemberData=res[2];
    //     this.memberTotals=res[3];
    //   }
    // );
    this._reporting.generateReportV2(this.params, this.practiceId).subscribe(
      res=>{
        this.reportData=res.data;
        this.showWorking=false;
      }
    );
  }

  public downloadReport(){
    this.showWorking=true;
    this._reporting.downloadReport(this.params, this.practiceId).subscribe(
      data=>{
        this.showWorking=false;
        let url = environment.apiEndpoint+data.download_path;
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download ='practice-report.csv';
        a.click();
        a.remove();
        this.deleteReport();
      }
    );
  }

  public deleteReport(){
    this._reporting.deleteCSV(this.practiceId).subscribe(res=>{
      // console.log(res);
    });
  }

  formatStartDate(event){
    this.params.fromDate=event.value.toISOString();
  }

  formatCloseDate(event){
    this.params.toDate=event.value.toISOString();
  }

  ngOnInit() {
    this.getPractice();
  }

}
